// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"d8e6357a","453":"deb3762b"}[chunkId] + ".chunk.js";
};